import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { LcsResponsiveTableModule, LcsTableModule } from '@lcs/shared/table';
import { PagedTableWrapperModule } from '@ndt/report-output/shared/paged-table-wrapper/paged-table-wrapper.module';
import { RegisterModule } from 'src/app/common-components/register/register.module';
import { FormatMinutesPipeModule } from 'src/app/pipes/format-minutes/format-minutes-pipe.module';
import { AddSpacesPipeModule } from 'src/app/pipes/split-enum-strings/add-spaces-pipe.module';
import { TilesModule } from '../../tiles.module';
import { SharedTileModule } from '../shared/shared-tile.module';
import { QueueMembersTileComponent } from './queue-members-tile.component';

@NgModule({
   declarations: [QueueMembersTileComponent],
   imports: [
      CommonModule,
      AddSpacesPipeModule,
      TilesModule,
      SharedTileModule,
      LcsResponsiveTableModule,
      ScrollingModule,
      RegisterModule,
      RouterModule,
      MatIconModule,
      PagedTableWrapperModule,
      LcsTableModule,
      FormatMinutesPipeModule,
   ],
   exports: [QueueMembersTileComponent],
})
export class QueueMembersTileModule {}
